export const ar = {
  nav: {
    overview: 'نظرة عامة', creators: 'Creators', followups: 'المتابعات', approvals: 'الموافقات',
    partnerships: 'الشراكات والعقود', contracts: 'العقود', agents: 'وكلاء الـAI', activity: 'النشاط',
    connectors: 'الموصلات', system: 'النظام', settings: 'الإعدادات',
    content: 'المحتوى', crm: 'CRM و Leads', social: 'السوشال ميديا', ads: 'الإعلانات',
    clients: 'العملاء', projects: 'المشاريع', finance: 'المالية',
    aiCommand: 'أوامر AI', aiOperations: 'عمليات AI',
    aiModels: 'نماذج AI', automations: 'الأتمتة', memory: 'الذاكرة المشتركة', agentLog: 'سجل الوكلاء', support: 'الدعم والتشخيص',
  },
  navGroups: {
    command: 'القيادة', operations: 'العمليات', growth: 'النمو',
    business: 'الأعمال', ai: 'الذكاء الاصطناعي والأتمتة', system: 'النظام',
  },
  common: {
    comingSoon: 'قريباً', viewAll: 'عرض الكل', close: 'إغلاق', live: 'مباشر', comingNext: 'قادم لاحقاً',
    notConnected: 'غير متصل', requiresBackend: 'يحتاج Backend', awaitingCredentials: 'بانتظار بيانات الاعتماد',
    preview: 'معاينة', copied: 'تم النسخ', copy: 'نسخ', export: 'تصدير CSV', print: 'طباعة', search: 'بحث',
    save: 'حفظ', cancel: 'إلغاء', savedLocallyDemo: 'محفوظ محلياً (تجريبي) — غير متصل بـbackend بعد',
    demoData: 'معاينة · بيانات تجريبية',
  },
  status: {
    creator: { active: 'نشِط', atRisk: 'At Risk', interested: 'مهتم', new: 'جديد', contacted: 'تم التواصل', application: 'طلب', pendingTiktok: 'بانتظار TikTok', joined: 'انضم', onboarding: 'تأهيل', inactive: 'غير نشِط', lost: 'مفقود', rejected: 'مرفوض' },
    partnership: { active: 'نشِطة', pending: 'بانتظار التوقيع', expired: 'منتهية', terminated: 'مُنهاة' },
    contract: { draft: 'مسودة', underReview: 'قيد المراجعة', waitingPartner: 'بانتظار الشريك', waitingUgarits: 'بانتظار Ugarits', ready: 'جاهز للتوقيع', partiallySigned: 'موقّع جزئياً', fullySigned: 'موقّع بالكامل', active: 'ساري', expiringSoon: 'قارب على الانتهاء', expired: 'منتهي', terminated: 'مُنهى', superseded: 'مستبدَل' },
    approval: { pending: 'بانتظار', approved: 'موافَق عليه', rejected: 'مرفوض', expired: 'منتهي', archived: 'مؤرشف' },
    followup: { open: 'مفتوحة', done: 'منجزة' },
    connector: { connected: 'متصل', pending: 'قيد الانتظار', awaiting: 'بانتظار الموافقة', error: 'خطأ', disabled: 'معطّل' },
    agent: { waitingCredentials: 'بانتظار بيانات الاعتماد', idle: 'خامل', running: 'يعمل', paused: 'متوقف مؤقتاً', error: 'خطأ', configuredPreview: 'مُعدّ (معاينة)' },
    system: { notConnected: 'غير متصل', operational: 'يعمل بشكل طبيعي', degraded: 'أداء متراجع', down: 'متوقف' },
    ledger: { notDue: 'غير مستحق', pending: 'بانتظار', approved: 'موافَق عليه', partiallyPaid: 'مدفوع جزئياً', paid: 'مدفوع', overdue: 'متأخر', disputed: 'محل نزاع' },
    automation: { draft: 'مسودة', waitingConnector: 'بانتظار الموصل', paused: 'متوقف مؤقتاً', archived: 'مؤرشف' },
  },
  permission: { level1: 'مستوى 1 — قراءة/مسودة', level2: 'مستوى 2 — يحتاج موافقة', level3: 'مستوى 3 — المالك فقط' },
  topbar: {
    openMenu: 'فتح القائمة',
    searchPlaceholder: 'ابحث عن أي شي أو اسأل Ugarits AI...',
    shortcutHint: '⌘K',
    notifications: 'الإشعارات',
    quickCreate: 'جديد',
  },
  overview: {
    needsAttention: 'يحتاج انتباهك', nothingNeedsAttention: 'لا يوجد ما يحتاج إلى انتباهك الآن.',
    pendingApprovals: 'موافقات معلّقة', overdueFollowups: 'متابعات متأخرة', atRiskCreators: 'صناع محتوى في خطر',
    expiringContracts: 'عقود قاربت على الانتهاء', systemIssues: 'مشاكل في النظام',
    today: 'اليوم', todaysFollowups: 'متابعات اليوم', noneToday: 'لا شيء مستحق اليوم.',
    recentActivity: 'النشاط الأخير', noRecentActivity: 'لا يوجد نشاط حديث.',
    business: 'الأعمال', aiOperations: 'عمليات الذكاء الاصطناعي',
    agentsConfigured: 'وكلاء مُعدّون', approvalQueue: 'قائمة الموافقات', connectorIssues: 'مشاكل الموصلات',
    aiProvidersLive: 'مزودو AI نشطون', quickActions: 'إجراءات سريعة', reviewApprovals: 'مراجعة الموافقات',
  },
  permissionConcept: {
    level0: { label: 'المستوى 0 — مراقبة', desc: 'يمكنه قراءة المعلومات المسموح بها صراحة فقط.' },
    level1: { label: 'المستوى 1 — استشارة', desc: 'يمكنه التحليل والتوصية.' },
    level2: { label: 'المستوى 2 — تحضير', desc: 'يمكنه تحضير إجراءات خارجية لكن يحتاج موافقة بشرية.' },
    level3: { label: 'المستوى 3 — تنفيذ', desc: 'يمكنه تنفيذ إجراءات منخفضة الخطورة مصرَّح بها مسبقاً وبشكل صريح. الإجراءات عالية الخطورة لا تصبح أوتوماتيكية أبداً بغض النظر عن المستوى.' },
  },
  agentDept: {
    executive: { name: 'تنفيذي', tagline: 'ينسّق المتخصصين، يوجّه المهام، يصعّد الموافقات' },
    operations: { name: 'العمليات', tagline: 'فرز الوارد، مراقبة سير العمل، ملخص العمليات اليومي' },
    creatorManager: { name: 'إدارة الـCreators', tagline: 'متابعات الـcreators، تحليل الخطورة، الاحتفاظ' },
    content: { name: 'المحتوى', tagline: 'بحث، مسودات، سكريبتات، خط الإنتاج' },
    sales: { name: 'المبيعات', tagline: 'تأهيل العملاء المحتملين، خط المبيعات، العروض' },
    growth: { name: 'النمو', tagline: 'بحث المنافسين، تحليل الحملات، SEO' },
    finance: { name: 'المالية', tagline: 'متابعة الفواتير، المستحقات، الملخصات' },
    analytics: { name: 'التحليلات', tagline: 'تقارير متعددة القنوات، رؤى الأعمال' },
    developer: { name: 'المطوّر', tagline: 'تشخيص، تحليل البناء، توصيات النشر' },
    support: { name: 'الدعم', tagline: 'تشخيص النظام، إرشادات الاستعادة' },
  },
  skills: {
    creatorFollowup: { name: 'متابعة Creator', desc: 'يصيغ رسالة متابعة لـcreator محدد.', input: 'معرّف الـCreator', output: 'مسودة رسالة (تحتاج موافقة)' },
    creatorRisk: { name: 'تحليل خطورة Creator', desc: 'يحدد الـcreators المعرّضين للخطر من بيانات التفاعل المحلية.', input: 'قائمة الـcreators', output: 'قائمة مرتبة حسب الخطورة' },
    creatorSummary: { name: 'ملخص Creator', desc: 'يلخّص حالة وسجل الـcreator.', input: 'معرّف الـCreator', output: 'ملخص مكتوب' },
    inboxTriage: { name: 'فرز الوارد', desc: 'يرتب الرسائل الواردة حسب الأولوية ويوجّهها.', input: 'صندوق وارد متصل', output: 'قائمة انتظار مرتبة' },
    competitorResearch: { name: 'بحث المنافسين', desc: 'يبحث عن منافس أو سوق محدد.', input: 'شركة/موضوع', output: 'ملخص بحث' },
    contentResearch: { name: 'بحث محتوى', desc: 'يبحث عن موضوع محتوى.', input: 'الموضوع', output: 'ملاحظات بحث' },
    contentBrief: { name: 'موجز محتوى', desc: 'ينتج موجز محتوى منظّم.', input: 'موضوع + هدف', output: 'مستند موجز (يحتاج موافقة)' },
    leadQualification: { name: 'تأهيل العميل المحتمل', desc: 'يقيّم ويؤهّل عميل محتمل وارد.', input: 'سجل العميل المحتمل', output: 'درجة تأهيل + ملاحظات' },
    contractSummary: { name: 'ملخص عقد', desc: 'يلخّص البنود الأساسية لعقد.', input: 'معرّف العقد', output: 'ملخص بلغة بسيطة' },
    dailyBrief: { name: 'الموجز التنفيذي اليومي', desc: 'يلخّص ما يحتاج انتباه اليوم من البيانات المحلية.', input: 'لا شيء — يقرأ من المستودعات المحلية', output: 'موجز مرتب حسب الأولوية' },
    systemDiagnostics: { name: 'تشخيص النظام', desc: 'يشغّل تشخيصات يمكن ملاحظتها من الواجهة الأمامية.', input: 'لا شيء', output: 'تقرير تشخيصي' },
  },
  skillStatus: {
    available_locally: 'متوفر محلياً', requires_connector: 'يحتاج موصل',
    requires_ai_provider: 'يحتاج مزوّد AI', disabled: 'معطّل',
  },
  commandRouter: {
    route: {
      command: 'أوامر Ugarits', router: 'موجّه الأوامر المحلي', unmatched: 'لا يوجد أمر محلي مطابق',
      approvalService: 'خدمة بيانات الموافقات', creatorService: 'خدمة بيانات الـCreators',
      followupService: 'خدمة بيانات المتابعات', contractService: 'خدمة بيانات العقود',
      activityService: 'خدمة بيانات النشاط', connectorService: 'خدمة بيانات الموصلات', systemService: 'خدمة بيانات النظام',
    },
    commands: {
      pendingApprovals: { title: 'موافقات معلّقة', desc: 'يعرض الموافقات التي تنتظر قراراً حالياً.' },
      creatorsAtRisk: { title: 'Creators في خطر', desc: 'يعرض الـcreators المصنّفين بخطورة عالية.' },
      overdueFollowups: { title: 'متابعات متأخرة', desc: 'يعرض المتابعات المفتوحة التي تجاوزت تاريخ الاستحقاق.' },
      expiringContracts: { title: 'عقود قاربت على الانتهاء', desc: 'يعرض العقود التي تنتهي ضمن فترة التحذير المُعدّة.' },
      recentActivity: { title: 'النشاط الأخير', desc: 'يعرض أحدث سجلات النشاط.' },
      connectorProblems: { title: 'مشاكل الموصلات', desc: 'يعرض الموصلات التي تُبلغ عن خطأ أو تحذير.' },
      systemStatus: { title: 'حالة النظام', desc: 'يعرض حالة خدمات الواجهة الأمامية/الخلفية.' },
    },
    empty: {
      noPendingApprovals: 'لا توجد موافقات معلّقة.', noAtRiskCreators: 'لا يوجد creators في خطر حالياً.',
      noOverdueFollowups: 'لا توجد متابعات متأخرة.', noExpiringContracts: 'لا توجد عقود قاربت على الانتهاء.',
      noActivity: 'لا يوجد نشاط حديث.', noConnectorProblems: 'لا توجد مشاكل موصلات.', noSystemServices: 'لا توجد خدمات نظام مُبلَّغة.',
    },
  },
  aiCommand: {
    title: 'أوامر AI', subtitle: 'الواجهة الأساسية بين الإنسان و Ugarits الذكية.',
    placeholder: 'اكتب أمراً، مثلاً: "أظهر الموافقات المعلّقة"...', run: 'تشغيل',
    suggested: 'أوامر مقترحة', recent: 'أوامر حديثة', noRecent: 'لم يتم تشغيل أي أمر بعد هذه الجلسة.',
    routing: 'التوجيه', localResult: 'نتيجة معاينة محلية', viewAll: 'فتح العرض الكامل',
    notConnectedTitle: 'مزوّد AI غير متصل',
    notConnectedBody: 'هذا الطلب يحتاج تفكيراً حياً، وهذا يتطلب تكامل مزوّد AI آمن على الـbackend غير متصل بعد. الأسئلة المحددة القابلة للإجابة من البيانات المحلية (مثل المقترحات أدناه) تعمل اليوم.',
    suggestions: {
      attention: 'شو يحتاج انتباهي اليوم؟', atRisk: 'أظهر الـcreators في خطر', pendingApprovals: 'أظهر الموافقات المعلّقة',
      overdueFollowups: 'أظهر المتابعات المتأخرة', expiringContracts: 'أظهر العقود المقاربة على الانتهاء',
      summarizeActivity: 'لخّص نشاط الوكالة', connectorProblems: 'أظهر مشاكل الموصلات',
      prepareFollowups: 'جهّز متابعات الـcreators', runDiagnostics: 'شغّل تشخيص النظام',
    },
  },
  aiOperations: {
    title: 'عمليات AI', subtitle: 'موجّه Ugarits والوكلاء المتخصصون.',
    orchestrator: 'موجّه Ugarits', orchestratorDesc: 'يوجّه العمل بين الوكلاء المتخصصين والمزوّدين ومحرك الموافقات. يملك التنسيق — المزوّدون محركات قابلة للاستبدال تحته.',
    specialistAgents: 'الوكلاء المتخصصون', notConfigured: 'غير مُعدّ بعد',
    status: 'الحالة', provider: 'المزوّد', model: 'النموذج', permission: 'الصلاحية', currentTask: 'المهمة الحالية',
    queue: 'قائمة الانتظار', lastActivity: 'آخر نشاط', tools: 'الأدوات', memoryScope: 'نطاق الذاكرة', approvalRequirement: 'متطلب الموافقة',
    lastError: 'آخر خطأ', none: 'لا شيء', empty: '—', noError: 'لا توجد أخطاء مسجّلة',
    opStatus: {
      configured_preview: 'إعداد معاينة', idle: 'خامل', active: 'نشط', working: 'يعمل',
      waiting_approval: 'بانتظار الموافقة', waiting_connector: 'بانتظار الموصل', paused: 'متوقف مؤقتاً', error: 'خطأ',
    },
    recentPreviewActivity: 'نشاط المعاينة الأخير', viewAgent: 'عرض في الوكلاء',
  },
  palette: {
    title: 'لوحة الأوامر',
    placeholder: 'اكتب أمر أو ابحث...',
    noResults: 'لا نتائج',
    goTo: 'انتقل إلى',
    new: 'جديد',
    create: 'إنشاء',
    actions: 'إجراءات',
    toggleTheme: 'تبديل المظهر',
    printPage: 'طباعة الصفحة الحالية',
    resetDemoData: 'إعادة تعيين البيانات التجريبية (فتح الإعدادات)',
    runDiagnostics: 'تشغيل التشخيص (فتح الدعم)',
    hint: 'تنقّل بـ ↑ ↓، اختيار بـ ↵، إغلاق بـ Esc',
  },
  notifications: {
    title: 'الإشعارات',
    empty: 'لا إشعارات حالياً — ما في شي يحتاج انتباهك.',
    markAllRead: 'تحديد الكل كمقروء',
    clear: 'إزالة',
    noRemoteDelivery: 'معاينة محلية فقط — ما في إرسال بريد إلكتروني أو push أو موبايل متصل.',
  },
  quickCreate: {
    title: 'إنشاء سريع',
    creator: 'صانع محتوى',
    partnership: 'شراكة',
    contract: 'عقد',
    followup: 'متابعة',
    agent: 'وكيل AI',
    automation: 'أتمتة',
    memory: 'سجل ذاكرة',
    content: 'محتوى',
    lead: 'Lead',
    client: 'عميل',
    project: 'مشروع',
    approvalNote: 'ملاحظة موافقة',
    fullName: 'الاسم الكامل',
    tiktok: 'اسم مستخدم TikTok',
  },
  recentlyViewed: { title: 'شوهد مؤخراً', empty: 'ما في شي انشاف بعد' },
  breadcrumbs: { home: 'نظرة عامة' },
  detail: {
    creatorTimeline: 'الجدول الزمني', creatorPerformance: 'سجل الأداء', nextAction: 'الإجراء التالي',
    nextFollowup: 'المتابعة القادمة', riskReason: 'سبب الخطر', auditHistory: 'سجل التدقيق',
    noTimelineYet: 'لا أحداث بعد — رح تظهر هون فور ما يصير فيه متابعات أو أتمتة مسجّلة لهاد الـcreator.',
    manualActivity: 'ملاحظة يدوية',
    addNotePlaceholder: 'أضف ملاحظة على الجدول الزمني لهاد الـcreator...',
  },
  partnershipDetail: {
    tabs: { overview: 'نظرة عامة', contacts: 'جهات الاتصال', contract: 'العقد', profitSharing: 'تقاسم الأرباح', ledger: 'الدفعات', documents: 'المستندات', activity: 'النشاط' },
    documentsEmpty: 'لا مستندات مرفوعة — تخزين العقود الموقّعة يحتاج object storage حقيقي (S3/MinIO) لسا ما تم توفيره.',
    ledgerEmpty: 'لا قيود دفتر أستاذ بعد — فترات تقاسم الأرباح ما بتنعمل بشكل وهمي؛ بتظهر فقط لما يتوصل البيانات المالية الحقيقية.',
    addContact: 'إضافة جهة اتصال',
  },
  env: { development: 'DEV', preview: 'معاينة', production: 'إنتاج' },
  system: {
    apiBackend: 'Backend API', notConnectedDetail: 'ما في backend منشور بعد — dataService.ts لسا بيقدّم بيانات تجريبية.',
    version: 'الإصدار', build: 'البناء', environment: 'البيئة',
  },
  rowMenu: {
    view: 'عرض', edit: 'تعديل', openFull: 'فتح السجل الكامل', archive: 'أرشفة', deleteDemo: 'حذف السجل التجريبي',
  },
  toast: {
    creatorAdded: 'تمت إضافة الـcreator', creatorUpdated: 'تم تحديث الـcreator', creatorArchived: 'تمت أرشفة الـcreator',
    demoRecordDeleted: 'تم حذف السجل التجريبي', activityAdded: 'تم تسجيل النشاط',
    followupScheduled: 'تمت جدولة المتابعة', followupCompleted: 'تم إنجاز المتابعة',
    approvalApproved: 'تمت الموافقة', approvalRejected: 'تم الرفض',
    partnershipCreated: 'تم إنشاء الشراكة', partnershipArchived: 'تمت أرشفة الشراكة',
    contactAdded: 'تمت إضافة جهة الاتصال',
    contractCreated: 'تم إنشاء العقد', contractUpdated: 'تم تحديث العقد',
    versionDuplicated: 'تم إنشاء نسخة جديدة', contractArchived: 'تمت أرشفة العقد',
    agentAdded: 'تمت إضافة وكيل AI', agentUpdated: 'تم تحديث وكيل AI', agentArchived: 'تمت أرشفة وكيل AI',
    calculationSaved: 'تم حفظ الحساب في دفتر الأستاذ (معاينة)', settingsSaved: 'تم حفظ الإعدادات',
    demoReset: 'تمت إعادة تعيين البيانات التجريبية', demoCleared: 'تم مسح البيانات التجريبية',
    automationAdded: 'تمت إضافة الأتمتة', automationUpdated: 'تم تحديث الأتمتة',
    automationArchived: 'تمت أرشفة الأتمتة', automationDuplicated: 'تم تكرار الأتمتة',
    memoryAdded: 'تمت إضافة سجل الذاكرة', memoryUpdated: 'تم تحديث سجل الذاكرة', memoryArchived: 'تمت أرشفة سجل الذاكرة',
  },
  confirm: {
    archiveCreatorTitle: 'أرشفة هذا الـcreator؟', archiveCreatorDesc: 'رح ينتقل الـcreator لحالة مؤرشفة. فيك تلاقيه مرة ثانية بالفلترة؛ هذا ما بيحذف أي شي بشكل دائم.',
    deleteCreatorTitle: 'حذف هذا السجل التجريبي؟', deleteCreatorDesc: 'رح يتحذف هذا السجل التجريبي نهائياً من بيانات المعاينة المحلية. ما فيك ترجع فيه.',
    deleteFollowupTitle: 'حذف هذه المتابعة؟', deleteFollowupDesc: 'رح تتحذف هذه المتابعة التجريبية نهائياً. ما فيك ترجع فيها.',
    deleteApprovalTitle: 'حذف هذه الموافقة التجريبية؟', deleteApprovalDesc: 'رح يتحذف سجل الموافقة التجريبي نهائياً. ما فيك ترجع فيه.',
    archivePartnershipTitle: 'أرشفة هذه الشراكة؟', archivePartnershipDesc: 'رح تنتقل الشراكة لحالة مؤرشفة وما رح تظهر بالعروض النشِطة.',
    archiveContractTitle: 'أرشفة هذا العقد؟', archiveContractDesc: 'رح ينتقل العقد لحالة مؤرشفة وما رح يظهر بالعروض النشِطة.',
    deleteAgentTitle: 'حذف هذا الوكيل التجريبي؟', deleteAgentDesc: 'رح يتحذف هذا الوكيل المُنشأ للمعاينة نهائياً. ما فيك ترجع فيه.',
    resetDemoTitle: 'إعادة تعيين كل البيانات التجريبية؟', resetDemoDesc: 'رح يتم استبدال كل شي بالبيانات الأصلية. أي سجلات أنشأتها أو عدّلتها رح تضيع.',
    clearDemoTitle: 'مسح كل البيانات التجريبية؟', clearDemoDesc: 'رح يتفرّغ كل سجل محلي (creators، متابعات، موافقات، شراكات، عقود، نشاط). كتالوج وكلاء الـAI والموصلات رح يضلوا لأنهم إعدادات مش بيانات. ما فيك ترجع بهاد الإجراء.',
    deleteAutomationTitle: 'حذف هذه الأتمتة التجريبية؟', deleteAutomationDesc: 'رح تتحذف هذه الأتمتة المُنشأة للمعاينة نهائياً. ما فيك ترجع فيها.',
    deleteMemoryTitle: 'حذف سجل الذاكرة التجريبي هذا؟', deleteMemoryDesc: 'رح يتحذف سجل الذاكرة المُنشأ للمعاينة نهائياً. ما فيك ترجع فيه.',
  },
  empty: {
    noCreators: 'ما في creators بهاد العرض حالياً.',
    noFollowups: 'ما في شي هون — كلك متابع.',
    noApprovals: 'ما في موافقات بهاد الفلتر.',
    noPartnerships: 'ما في شراكات بعد.',
    noContracts: 'ما في عقود بعد.',
    noContacts: 'ما تمت إضافة جهات اتصال بعد.',
  },
  creatorForm: { editTitle: 'تعديل Creator', createTitle: 'Creator جديد' },
  creatorViews: { all: 'الكل', active: 'نشِط', need_followup: 'يحتاج متابعة', at_risk: 'At Risk', pending_tiktok: 'بانتظار TikTok', allRisk: 'كل مستويات الخطر' },
  followupForm: {
    defaultTitle: 'متابعة', schedule: 'جدولة متابعة', creator: 'Creator', title: 'العنوان',
    due: 'الاستحقاق', markDone: 'إنجاز', reopen: 'إعادة فتح',
  },
  followupViews: { today: 'اليوم', overdue: 'متأخرة', upcoming: 'قادمة', completed: 'منجزة', all: 'الكل' },
  approvalFilters: { pending: 'بانتظار', approved: 'موافَق عليه', rejected: 'مرفوض', archived: 'مؤرشف', all: 'الكل' },
  approvalDetail: { show: 'عرض التفاصيل', hide: 'إخفاء التفاصيل', approve: 'موافقة', reject: 'رفض' },
  partnershipForm: {
    newPartnership: 'شراكة جديدة', editTitle: 'تعديل الشراكة', createTitle: 'شراكة جديدة',
    partnerName: 'اسم الشريك', legalName: 'الاسم القانوني', type: 'النوع', industry: 'المجال', website: 'الموقع الإلكتروني',
  },
  profitSharing: {
    previewCalculation: 'حساب معاينة',
    disclaimer: 'هذا حساب معاينة محلي فقط — مش استشارة محاسبية أو قانونية. تأكد من كل الأرقام قبل ما تتصرف بناءً عليها.',
    method: 'الطريقة', period: 'الفترة', revenue: 'الإيراد', eligibleRevenue: 'الإيراد المستحق',
    partnerPct: 'نسبة الشريك %', fixedAmount: 'مبلغ ثابت', adjustments: 'تعديلات',
    partnerShare: 'حصة الشريك', ugaritsShare: 'حصة Ugarits', balance: 'الرصيد', saveDemo: 'حفظ الحساب التجريبي',
  },
  documents: {
    previewOnly: 'معاينة فقط — اسم الملف معروض محلياً، مش مخزّن بشكل آمن على سيرفر لسا.',
    selected: 'مُختار', remove: 'إزالة',
  },
  contractForm: {
    newContract: 'عقد جديد', editTitle: 'تعديل العقد', partnership: 'الشراكة', partnershipRequired: 'اختر شراكة',
    title: 'العنوان', titleRequired: 'العنوان مطلوب', type: 'النوع', version: 'النسخة', effectiveDate: 'تاريخ السريان',
    expiryDate: 'تاريخ الانتهاء', currency: 'العملة', value: 'القيمة', duplicateVersion: 'نسخ كنسخة جديدة',
  },
  agentForm: {
    newAgent: 'وكيل AI جديد', editTitle: 'تعديل وكيل AI', name: 'الاسم', role: 'الدور', department: 'القسم', provider: 'المزوّد', model: 'الموديل',
    permissionLevel: 'مستوى الصلاحية', description: 'الوصف', allowedActions: 'إجراءات مسموحة',
    forbiddenActions: 'إجراءات ممنوعة', required: 'مطلوب', pause: 'إيقاف مؤقت', resume: 'استئناف',
  },
  connectors: {
    honestyNote: 'ولا وحدة من هاي اتصالات حقيقية — تفعيل واحد هون بس بيشغّل حالة المعاينة بالواجهة. مزامنة البيانات الحقيقية تحتاج تكامل backend حقيقي للموصل.',
    enabled: 'مفعّل', disabled: 'معطّل', viewDetails: 'عرض التفاصيل', enable: 'تفعيل', disable: 'تعطيل',
    status: 'الحالة', editLabel: 'التسمية', notes: 'ملاحظات', requiresLiveIntegration: 'يحتاج تكامل حقيقي للاتصال',
  },
  settingsSections: {
    general: 'عام', branding: 'الهوية البصرية', appearance: 'المظهر', language: 'اللغة', notifications: 'تفضيلات الإشعارات',
    creatorRules: 'Creators', followupRules: 'المتابعات', approvalRules: 'الموافقات',
    partnershipRules: 'الشراكات', contractRules: 'العقود', agentRules: 'الوكلاء', automationRules: 'الأتمتة',
    export: 'إعدادات التصدير', aiProviders: 'مزوّدي AI', security: 'الأمان', data: 'البيانات',
    connectors: 'الموصلات', developer: 'المطوّر', support: 'الدعم',
  },
  settingsFields: {
    companyName: 'اسم الشركة', legalName: 'الاسم القانوني', timezone: 'المنطقة الزمنية', defaultCurrency: 'العملة الافتراضية',
    defaultLandingRoute: 'الصفحة الافتراضية عند الدخول', environment: 'البيئة', theme: 'المظهر', density: 'الكثافة',
    sidebarCollapsed: 'طي القائمة الجانبية افتراضياً', reducedMotion: 'تقليل الحركة', appLanguage: 'لغة التطبيق',
    dateFormat: 'صيغة التاريخ', numberFormat: 'صيغة الأرقام',
    appName: 'اسم التطبيق', brandColor: 'لون العلامة التجارية', logoStatus: 'الشعار', noLogo: 'لم يتم رفع شعار بعد',
    logoNote: 'رفع ملف شعار حقيقي يحتاج مخزن ملفات على الـbackend — غير مموّه هنا.',
    notif: {
      followupDue: 'استحقاق متابعة', approvalWaiting: 'موافقة بانتظار', creatorAtRisk: 'Creator at risk',
      contractExpiring: 'عقد على وشك الانتهاء', systemAlerts: 'تنبيهات النظام',
      disclaimer: 'هاي بتتحكم بأي عناصر بتظهر بمركز الإشعارات محلياً — ما في إرسال بريد إلكتروني أو push أو SMS.',
    },
    defaultFollowupDays: 'أيام المتابعة الافتراضية', riskThresholdDays: 'حد الخطر (أيام)', defaultOwner: 'المسؤول الافتراضي',
    idPrefix: 'بادئة المعرّف',
    defaultPriority: 'الأولوية الافتراضية', overdueBehavior: 'سلوك التأخير', overdueBehaviorFlag: 'وضع علامة فقط',
    overdueBehaviorEscalate: 'علامة + تصعيد', reminderEnabled: 'تذكير قبل تاريخ الاستحقاق',
    defaultPermissionLevel: 'مستوى الصلاحية الافتراضي', expirationDays: 'تنتهي بعد (أيام)', highRiskConfirm: 'طلب تأكيد للموافقات عالية الخطورة',
    renewalWarningDays: 'تنبيه التجديد (أيام قبل)', expiryWarningDays: 'تنبيه الانتهاء (أيام قبل)', defaultNoticePeriodDays: 'مدة الإشعار الافتراضية (أيام)',
    agentDefaultsNote: 'تُطبّق كافتراضي عند إنشاء وكيل جديد. التطبيق الفعلي لمستويات الصلاحية يتم عبر محرك الموافقات بمجرد أن يعمل الوكلاء مع مزوّد حقيقي.',
    defaultFileType: 'نوع ملف التصدير الافتراضي', pdfUnavailable: 'PDF (غير متوفر بهذا الإصدار)',
    includeBranding: 'تضمين هوية Ugarits بالتصدير', includeTimestamp: 'تضمين الطابع الزمني بالتصدير',
    fileNamePrefix: 'بادئة اسم الملف المُصدَّر',
    aiKeyNote: 'مفاتيح الـAPI ما بتتخزن أبداً بالمتصفح. ربط مزوّد حقيقي يحتاج backend يحفظ بيانات الاعتماد بأمان.',
    dataMode: 'وضع البيانات', demoDataExplanation: 'هذا التطبيق يعمل على بيانات معاينة محلية مخزنة بمتصفحك. إعادة التعيين بترجع البيانات الأصلية؛ المسح بيفرّغ كل سجل.',
    resetDemoData: 'إعادة تعيين البيانات التجريبية', clearAllDemoData: 'مسح كل البيانات التجريبية',
    connectorsSummary: 'موصلات مُعدّة', viewConnectors: 'فتح الموصلات',
    appVersion: 'إصدار التطبيق', buildInfo: 'هذه نسخة معاينة — لا توجد بيانات CI/CD متاحة بهذه البيئة.',
    supportNotBuilt: 'قسم الدعم والتشخيص غير مبني بعد — لا شيء هنا مموّه. هذا القسم سيعرض تفضيلات التشخيص ودعم AI ومشاركة السجلات بمجرد إطلاق هذه الوحدة.',
    defaultApprovalLevel: 'مستوى الموافقة الافتراضي للأتمتة',
    automationDefaultsNote: 'تُطبّق كافتراضي عند إنشاء أتمتة جديدة — راجع الأتمتة.',
    diagnosticsReminder: 'ذكّرني بتشغيل التشخيص بشكل دوري',
    diagnosticsReminderNote: 'تفضيل محلي فقط — لا توجد مهمة خلفية مجدولة لإرسال تذكير فعلي بعد.',
    agentLogRetentionNote: 'سجلات وكلاء الـAI تُحفظ فقط بتخزين المعاينة المحلي لهذا المتصفح؛ لا توجد سياسة احتفاظ على سيرفر بعد.',
    openSupport: 'فتح الدعم والتشخيص',
  },
  askAi: {
    title: 'اسأل Ugarits AI', notConnected: 'ما في مزوّد AI متصل — هاد بس بيشغّل مجموعة صغيرة من الاستعلامات المحلية الآمنة على بيانات المعاينة.',
    placeholder: 'اسأل عن الـcreators at risk، الموافقات المعلّقة، العقود قاربت تنتهي...', run: 'تشغيل',
    localResult: 'نتيجة معاينة محلية',
    examples: 'جرّب وحدة من هاي',
    example: {
      whatNeedsAttention: 'شو يحتاج انتباهي؟',
      showAtRisk: 'اعرض الـcreators at risk',
      showPendingApprovals: 'اعرض الموافقات المعلّقة',
      showExpiringContracts: 'اعرض العقود قاربت تنتهي',
    },
    shortLabel: 'اسأل AI',
  },
  footer: { brand: 'Ugarits Command Center', poweredBy: 'مقدّم من Ugarits Marketing FZ-LLC', developerCredit: 'المطور: Maher Moustafa' },
  comingSoon: { explanation: 'هاد الموديول مخطط له بس لسا ما انبنى. ما في شي هون وهمي أو متصل — هاي معاينة حقيقية لإيش جاي.', planned: 'القدرات المخطط لها' },
  diagnostics: {
    requiresBackendCheck: 'يحتاج تحقق من الـBackend',
    labels: {
      frontendLoad: 'حالة تحميل الواجهة الأمامية', currentRoute: 'المسار الحالي', appVersion: 'إصدار التطبيق',
      environment: 'البيئة', dataMode: 'وضع البيانات', browser: 'المتصفح', language: 'اللغة', theme: 'المظهر',
      system: 'النظام', connectorsTotal: 'الموصلات المُعدّة', connectorsWithProblem: 'موصلات فيها مشكلة',
      configuredAgents: 'الوكلاء المُعدّون', aiProvidersConnected: 'مزوّدو AI المتصلون',
    },
    values: { frontendLoadOk: 'تمام — هاي الصفحة اتحمّلت' },
  },
  support: {
    subtitle: 'تشخيص، رؤية الأخطاء، وإرشادات استعادة محلية آمنة — لا شيء هنا مموّه.',
    systemHealth: 'صحة النظام', diagnostics: 'التشخيص', runDiagnostics: 'تشغيل التشخيص', running: 'قيد التشغيل…',
    issuesFound: 'المشاكل المكتشفة',
    col: { service: 'الخدمة', status: 'الحالة', detail: 'التفاصيل', version: 'الإصدار' },
    recentErrors: 'أخطاء حديثة', noErrors: 'لا توجد أخطاء مسجّلة.',
    connectorProblems: 'مشاكل الموصلات', noConnectorProblems: 'لا توجد مشاكل موصلات.',
    aiProviderProblems: 'مشاكل مزوّدي AI', noAiProvidersConnected: 'ما في مزوّد AI متصل بعد.',
    appInfo: 'معلومات التطبيق',
    supportAssistant: 'مساعد الدعم',
    assistantPlaceholder: 'اوصف المشكلة اللي عم تشوفها...',
    assistantRun: 'تنظيف ومراجعة', assistantSanitized: 'النص المنظّف (اللي رح يتشارك)',
    assistantRedactedCount: 'عناصر تمت إزالتها', assistantNoRedactions: 'ما تم إيجاد أنماط تشبه بيانات اعتماد.',
    assistantHonestNote: 'التحليل التقني بالـAI يحتاج تكامل مزوّد آمن — هاد النص ما بينبعت لأي مكان أبداً.',
    recoveryGuidance: 'إرشادات الاستعادة',
    recoverySteps: {
      reload: 'أعد تحميل الصفحة — معظم مشاكل العرض بتنحل بتحميل جديد.',
      checkConnectors: 'راجع صفحة الموصلات لموصل يُبلغ عن خطأ أو تحذير.',
      checkSystem: 'راجع صفحة النظام لحالة الاتصال بالـbackend/قاعدة البيانات.',
      resetDemo: 'إذا بدت بيانات المعاينة المحلية تالفة، استخدم الإعدادات ← إعادة تعيين البيانات التجريبية (بيلغي التعديلات المحلية).',
    },
  },
  aiModels: {
    subtitle: 'جدول التوجيه بين الأقسام والنماذج اللي رح تستخدمها بمجرد اتصال مزوّد حقيقي.',
    provider: 'المزوّد', model: 'النموذج', purposeCol: 'الغرض', status: 'الحالة', configured: 'مُعدّ',
    note: 'ربط مزوّد حقيقي يحتاج تخزين بيانات اعتماد على الـbackend — ما في مفتاح API يتم إدخاله أو تخزينه بهاد المتصفح أبداً.',
    purpose: {
      executive: 'تفكير تنفيذي وترتيب أولويات', creator_manager: 'متابعات الـcreators والاحتفاظ',
      content_director: 'خط إنتاج المحتوى', social_analytics: 'تحليلات متعددة القنوات',
      sales: 'تواصل الشراكات والـleads', developer: 'تشخيص النظام وصيانة الأتمتة',
    },
  },
  automations: {
    subtitle: 'تعريفات أتمتة معاينة محلية. ما في backend تنفيذ أو مجدول لسا — الحالة أبداً مش "نشِطة".',
    empty: 'ما في أتمتة بعد.', duplicate: 'تكرار', unassigned: 'غير مُعيَّن',
    col: { status: 'الحالة', lastRun: 'آخر تشغيل', nextRun: 'التشغيل القادم' },
  },
  automationForm: {
    newTitle: 'أتمتة جديدة', editTitle: 'تعديل الأتمتة', name: 'الاسم', description: 'الوصف',
    trigger: 'المُشغّل', conditions: 'الشروط', actions: 'الإجراءات', ownerAgent: 'الوكيل المسؤول',
    approvalLevel: 'مستوى الموافقة', required: 'الاسم والمُشغّل والإجراءات مطلوبة',
  },
  memory: {
    badge: 'ذاكرة Ugarits — معاينة محلية فقط',
    subtitle: 'قاعدة معرفة محلية مشتركة للوكلاء والأقسام. ما في vector store أو embeddings بعد.',
    searchPlaceholder: 'ابحث بالعنوان أو المحتوى أو الوسوم...', allDomains: 'كل المجالات',
    plainTextSearchNote: 'بحث نصي بسيط فقط — مش بحث دلالي/AI.',
    empty: 'ما في سجلات ذاكرة تطابق هذا الفلتر.', agentAccessCount: 'وكلاء لديهم صلاحية وصول',
  },
  memoryDomain: {
    company: 'الشركة', brand: 'العلامة التجارية', services: 'الخدمات', sop: 'إجراءات العمل', creators: 'Creators', clients: 'العملاء',
    leads: 'Leads', partnerships: 'الشراكات', contracts: 'العقود', projects: 'المشاريع', content: 'المحتوى',
    decisions: 'القرارات', knowledge: 'المعرفة', agent_learnings: 'ما تعلمه الوكلاء',
  },
  memoryForm: {
    newTitle: 'سجل ذاكرة جديد', editTitle: 'تعديل سجل الذاكرة', title: 'العنوان', domain: 'المجال', content: 'المحتوى',
    source: 'المصدر', tags: 'الوسوم', tagsPlaceholder: 'وسوم مفصولة بفاصلة', visibility: 'الظهور',
    visibilityTeam: 'الفريق', visibilityPrivate: 'خاص', agentAccess: 'صلاحية وصول الوكلاء',
    required: 'العنوان والمحتوى مطلوبان',
  },
  agentLog: {
    subtitle: 'عرض للقراءة فقط لكل حدث نشاط بالمعاينة المحلية — إجراءات الوكلاء والمستخدمين والنظام كلها.',
    actor: { all: 'كل الفاعلين', agent: 'وكيل', user: 'مستخدم', system: 'نظام' },
    result: { all: 'كل النتائج', good: 'جيد', warn: 'تحذير', crit: 'حرج', info: 'معلومة' },
    col: { when: 'الوقت', actorType: 'نوع الفاعل', actor: 'الفاعل', action: 'الإجراء', target: 'الهدف', result: 'النتيجة', usage: 'استهلاك التوكن' },
    usageUnavailable: 'غير متوفر حتى يتم ربط مزوّد',
    empty: 'ما في نشاط يطابق هذا الفلتر.',
  },
};
